import { render, staticRenderFns } from "./OrganizerDashboard.vue?vue&type=template&id=1d12382c&"
import script from "./OrganizerDashboard.vue?vue&type=script&lang=js&"
export * from "./OrganizerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports